export enum GlycolType {
    Propylenglycol = "Propylenglycol",
    Monoethylenglycol = "Monoethylenglycol"
}